import { render, staticRenderFns } from "./ProjectLinkage.vue?vue&type=template&id=caa153fc&scoped=true"
import script from "./ProjectLinkage.vue?vue&type=script&lang=js"
export * from "./ProjectLinkage.vue?vue&type=script&lang=js"
import style0 from "./ProjectLinkage.vue?vue&type=style&index=0&id=caa153fc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caa153fc",
  null
  
)

export default component.exports